import { defineMessages } from 'react-intl';

export const discountsMessages = defineMessages({
    discountsBadge: {
        id: 'discounts-badge',
        defaultMessage: 'Discounts',
    },
    discount: {
        id: 'discount',
        defaultMessage: 'Discount',
    },
    startDate: {
        id: 'start-date',
        defaultMessage: 'Start date',
    },
    endDate: {
        id: 'end-date',
        defaultMessage: 'End date',
    },
    discounts: {
        id: 'discounts',
        defaultMessage: 'Discounts',
    },
    createDiscountSuccess: {
        id: 'create-discount-success',
        defaultMessage: 'Discount created',
    },
    createDiscountSuccessDescription: {
        id: 'create-discount-success-description',
        defaultMessage: 'The discount has been successfully created.',
    },
    addDiscountSubtitle: {
        id: 'add-discount-subtitle',
        defaultMessage: 'Create a new discount',
    },
    missingServicePlanTermsError: {
        id: 'custom-error:missing_service_plan_terms_error',
        defaultMessage: "Discount cannot be linked to service plan which doesn't have defined terms!",
    },
    differentCurrencyError: {
        id: 'custom-error:discount_and_subscription_currency_mismatch_error',
        defaultMessage: 'Discount cannot be linked to service plan which has different currency!',
    },
    deleteDiscount: {
        id: 'delete-discount',
        defaultMessage: 'Delete discount',
    },
    deleteDiscountSuccess: {
        id: 'delete-discount-success',
        defaultMessage: 'Discount deleted',
    },
    deleteDiscountSuccessDescription: {
        id: 'delete-discount-success-description',
        defaultMessage: 'The discount has been successfully deleted.',
    },
    confirmDeleteDiscount: {
        id: 'confirm-delete-discount',
        defaultMessage: 'Are you sure you want to delete this discount? This action cannot be undone.',
    },
    deleteDiscountSubtitle: {
        id: 'delete-discount-subtitle',
        defaultMessage: 'Permanently delete discount',
    },
    backToAllDiscounts: {
        id: 'back-to-all-discounts',
        defaultMessage: 'Back to all discounts',
    },
    discountDashboard: {
        id: 'discount-dashboard',
        defaultMessage: 'Discount dashboard',
    },
    editDiscountSubtitle: {
        id: 'edit-discount-subtitle',
        defaultMessage: 'Edit discount',
    },
    updateDiscountSuccess: {
        id: 'update-discount-success',
        defaultMessage: 'Discount updated',
    },
    updateDiscountSuccessDescription: {
        id: 'update-discount-success-description',
        defaultMessage: 'The discount has been successfully updated.',
    },
});
